/**
 * @generated SignedSource<<a94901ad183435f935c05fa833202341>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FormMetadataStyleEnum = "ImageCenter" | "ImageLeft" | "NoImage";
export type FormMetadataTemplateEnum = "Basic" | "CompanyLong" | "CompanyShort" | "PasswordProtected" | "PasswordProtectedShort";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
export type Form_Single_Query$variables = {
  id: string;
};
export type Form_Single_Query$data = {
  readonly form: {
    readonly author: {
      readonly node: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly slug: string | null | undefined;
        readonly username: string | null | undefined;
      };
    } | null | undefined;
    readonly content: string | null | undefined;
    readonly email: {
      readonly admins: {
        readonly body: string | null | undefined;
        readonly emails: ReadonlyArray<string | null | undefined> | null | undefined;
        readonly enabled: boolean | null | undefined;
        readonly subject: string | null | undefined;
      } | null | undefined;
      readonly visitor: {
        readonly body: string | null | undefined;
        readonly enabled: boolean | null | undefined;
        readonly subject: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly imageUrl: string | null | undefined;
    readonly marketingConsent: boolean | null | undefined;
    readonly metadata: {
      readonly cookieExpiration: string | null | undefined;
      readonly formStyle: FormMetadataStyleEnum | null | undefined;
      readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
      readonly submitSuccessText: string | null | undefined;
    } | null | undefined;
    readonly password: boolean | null | undefined;
    readonly schema: string | null | undefined;
    readonly status: PostStatusEnum | null | undefined;
    readonly statusSettings: {
      readonly approved: {
        readonly id: string | null | undefined;
        readonly timestamp: string | null | undefined;
        readonly user: {
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly stateWhenApproved: {
        readonly status: PostStatusEnum | null | undefined;
        readonly uiPermission: {
          readonly type: StatusUiPermissionEnum | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly status: PostStatusEnum | null | undefined;
      readonly uiPermission: {
        readonly type: StatusUiPermissionEnum | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly title: string;
    readonly uiSchema: string | null | undefined;
  } | null | undefined;
};
export type Form_Single_Query = {
  response: Form_Single_Query$data;
  variables: Form_Single_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "NodeWizAuthorToUserConnectionEdge",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "StateWhenApproved",
  "kind": "LinkedField",
  "name": "stateWhenApproved",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "schema",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uiSchema",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "EmailSettings",
  "kind": "LinkedField",
  "name": "email",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailSettingsField",
      "kind": "LinkedField",
      "name": "admins",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emails",
          "storageKey": null
        },
        (v14/*: any*/),
        (v15/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailSettingsField",
      "kind": "LinkedField",
      "name": "visitor",
      "plural": false,
      "selections": [
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "password",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "FormMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formStyle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formTemplate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cookieExpiration",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submitSuccessText",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketingConsent",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Form_Single_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Form",
        "kind": "LinkedField",
        "name": "form",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusSettings",
            "kind": "LinkedField",
            "name": "statusSettings",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ApprovedState",
                "kind": "LinkedField",
                "name": "approved",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Form_Single_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Form",
        "kind": "LinkedField",
        "name": "form",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusSettings",
            "kind": "LinkedField",
            "name": "statusSettings",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ApprovedState",
                "kind": "LinkedField",
                "name": "approved",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v12/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "21801b1e5b1059c01145d466dfc90f86",
    "id": null,
    "metadata": {},
    "name": "Form_Single_Query",
    "operationKind": "query",
    "text": "query Form_Single_Query(\n  $id: ID!\n) {\n  form(id: $id) {\n    id\n    author {\n      node {\n        id\n        name\n        username\n        slug\n      }\n    }\n    title\n    content\n    status\n    statusSettings {\n      status\n      uiPermission {\n        type\n      }\n      stateWhenApproved {\n        status\n        uiPermission {\n          type\n        }\n      }\n      approved {\n        id\n        timestamp\n        user {\n          name\n          id\n        }\n      }\n    }\n    schema\n    uiSchema\n    email {\n      admins {\n        enabled\n        emails\n        body\n        subject\n      }\n      visitor {\n        enabled\n        body\n        subject\n      }\n    }\n    password\n    metadata {\n      formStyle\n      formTemplate\n      cookieExpiration\n      submitSuccessText\n    }\n    imageUrl\n    marketingConsent\n  }\n}\n"
  }
};
})();

(node as any).hash = "7fccd949668e8d59a79f3399af65a4f7";

export default node;
